import TermDepositDetailWrapper from "@/modules/savings/TermDepositeDetailWrapper";

const TermDepositDetailPage = () => {
  return <TermDepositDetailWrapper />;
};
export default TermDepositDetailPage;
